var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1,
    height: 72,
    viewBox: "0 0 1 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    y2: 72,
    transform: "translate(0.5)",
    fill: "none",
    stroke: "#181818",
    strokeWidth: 1,
    strokeDasharray: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticleLine);
export default __webpack_public_path__ + "static/media/verticle-line.e76be22550662cd0d6eb020a53283f60.svg";
export { ForwardRef as ReactComponent };